import React from 'react';
import { ClockIcon, MailIcon, MapPinIcon, PhoneIcon, SmartphoneIcon } from 'lucide-react';
import { business, navLinks, socials } from '../data/site';
const mapsHref = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(`${business.address.street}, ${business.address.city}, ${business.address.state} ${business.address.zip}`)}`;
export function SiteFooter() {
  return <footer id="contact" className="w-full bg-ink text-white" data-id="element-192" data-mp="3dh4kqqe1z1fl">
      <div className="mx-auto max-w-shell px-5 py-16 lg:px-8 lg:py-20" data-id="element-193" data-mp="38hrnrctgwdza">
        <div className="grid gap-12 lg:grid-cols-[minmax(0,1fr)_minmax(0,520px)] lg:gap-16" data-id="element-194" data-mp="38gglxijl1gat">
          <div data-id="element-195" data-mp="33j6vbzkgiyle">
            <img src={business.logoUrl} alt={`${business.name} logo`} className="h-14 w-auto" data-id="element-196" data-mp="33krj96c9njaa" />
            <p className="mt-6 max-w-[420px] text-[16px] leading-relaxed text-chalk/70" data-id="element-197" data-mp="11rk0to1cwlk6">
              Specializing in professional results. Give us a call today to
              learn more about the East End Automotive Way!
            </p>

            <a href={business.phoneHref} className="mt-7 inline-flex items-center gap-3 whitespace-nowrap rounded-md bg-brand px-6 py-3.5 font-display text-base font-bold text-white transition-colors duration-150 ease-out hover:bg-brand-light" data-id="element-198" data-mp="15sy94f00pwyp">
              <PhoneIcon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-199" data-mp="10sag5ns8b61u" />
              Call {business.phone}
            </a>

            <dl className="mt-10 grid gap-6 sm:grid-cols-2" data-id="element-200" data-mp="1ojpfr8smf99e">
              <div data-id="element-201" data-mp="1tfwm32oximrv">
                <dt className="flex items-center gap-2 text-[12px] font-bold uppercase tracking-[0.14em] text-chalk/45" data-id="element-202" data-mp="1tiis2xw68u7z">
                  <MapPinIcon className="h-4 w-4" aria-hidden="true" data-id="element-203" data-mp="1jqms1haiyu14" />
                  Address
                </dt>
                <dd className="mt-2 text-[15px] leading-relaxed text-chalk/85" data-id="element-204" data-mp="27fpa2q92mow5">
                  <a href={mapsHref} target="_blank" rel="noreferrer" className="hover:text-brand-light" data-id="element-205" data-mp="2c6xjvnebcc9u">
                    {business.address.street}
                    <br data-id="element-206" data-mp="2m1mjfwshvwjn" />
                    {business.address.city}, {business.address.state}{' '}
                    {business.address.zip}
                  </a>
                </dd>
              </div>
              <div data-id="element-207" data-mp="2d0ohdk1m9z3p">
                <dt className="flex items-center gap-2 text-[12px] font-bold uppercase tracking-[0.14em] text-chalk/45" data-id="element-208" data-mp="2d4ca4gz8mhhd">
                  <ClockIcon className="h-4 w-4" aria-hidden="true" data-id="element-209" data-mp="2341yv1wrjk4u" />
                  Hours
                </dt>
                <dd className="mt-2 space-y-1 text-[15px] text-chalk/85" data-id="element-210" data-mp="1yctkrskhnalc">
                  {business.hours.map(h => <p key={h.days} data-id="element-211" data-mp="1tfa5qqfyutsc">
                      <span className="text-chalk/55" data-id="element-212" data-mp="1tc5u58068vrn">{h.days}:</span> {h.time}
                    </p>)}
                </dd>
              </div>
              <div data-id="element-213" data-mp="1kc92qymedisw">
                <dt className="flex items-center gap-2 text-[12px] font-bold uppercase tracking-[0.14em] text-chalk/45" data-id="element-214" data-mp="1kcsl2gfym97g">
                  <SmartphoneIcon className="h-4 w-4" aria-hidden="true" data-id="element-215" data-mp="1fgtsegnlm518" />
                  Mobile
                </dt>
                <dd className="mt-2 text-[15px] text-chalk/85" data-id="element-216" data-mp="3w0npkbc7vncc">
                  <a href={business.mobileHref} className="hover:text-brand-light" data-id="element-217" data-mp="3w30h9g7s1c2l">
                    {business.mobile}
                  </a>
                </dd>
              </div>
              <div data-id="element-218" data-mp="8vodcii9b3s5">
                <dt className="flex items-center gap-2 text-[12px] font-bold uppercase tracking-[0.14em] text-chalk/45" data-id="element-219" data-mp="8u3pfbqg6j39">
                  <MailIcon className="h-4 w-4" aria-hidden="true" data-id="element-220" data-mp="3da6bncw1mwb1" />
                  Email
                </dt>
                <dd className="mt-2 break-all text-[15px] text-chalk/85" data-id="element-221" data-mp="3hbhqqohajz4z">
                  <a href={`mailto:${business.email}`} className="hover:text-brand-light" data-id="element-222" data-mp="3m2q1bnucxqjq">
                    {business.email}
                  </a>
                </dd>
              </div>
            </dl>
          </div>

          <div data-id="element-223" data-mp="2tkcdmh2qjkyd">
            <div className="overflow-hidden rounded-xl border border-white/10 bg-charcoal" data-id="element-224" data-mp="2ahtq4pb0ocyb">
              <iframe title={`Map to ${business.name}`} src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d133215.55905742524!2d-84.29857806571366!3d36.039597510203855!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x885c35618fed1a4d%3A0x571016364ac6f4d6!2sEast%20End%20Automotive%20Repair!5e1!3m2!1sen!2sus!4v1786721526509!5m2!1sen!2sus" loading="lazy" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen className="block h-[300px] w-full border-0 sm:h-[340px] lg:h-[400px]" data-id="element-225" data-mp="2afh9cfgzw8mu" />
              <a href={mapsHref} target="_blank" rel="noreferrer" className="flex items-center justify-between gap-4 border-t border-white/10 px-5 py-4 text-[14px] font-semibold text-chalk/80 transition-colors duration-150 ease-out hover:text-white" data-id="element-226" data-mp="2y7eks5gj8ynf">
                <span className="inline-flex items-center gap-2" data-id="element-227" data-mp="3fggxydixw866">
                  <MapPinIcon className="h-4 w-4 shrink-0 text-brand-light" aria-hidden="true" data-id="element-228" data-mp="3kftqnewhs9go" />
                  274 Warehouse Rd, Oak Ridge, TN
                </span>
                <span className="whitespace-nowrap text-brand-light" data-id="element-229" data-mp="3ap8k95aku0n7">
                  Get directions
                </span>
              </a>
            </div>

            <nav aria-label="Footer" className="mt-8 flex flex-wrap gap-x-6 gap-y-3" data-id="element-230" data-mp="2wslnb2imjaha">
              {navLinks.map(link => <a key={link.href} href={link.href} className="text-[13px] font-semibold uppercase tracking-[0.08em] text-chalk/60 transition-colors duration-150 ease-out hover:text-white" data-id="element-231" data-mp="2mskzb39t866r">
                  {link.label}
                </a>)}
            </nav>

            <ul className="mt-6 flex flex-wrap gap-2.5" data-id="element-232" data-mp="pyzzk9xhzgwu">
              {socials.map(s => <li key={s.label} data-id="element-233" data-mp="ojxbpiamtjkh">
                  <a href={s.href} target="_blank" rel="noreferrer" className="inline-flex rounded-md border border-white/15 px-3.5 py-2 text-[13px] font-semibold text-chalk/75 transition-colors duration-150 ease-out hover:border-brand hover:text-white" data-id="element-234" data-mp="jjj4g2guudni">
                    {s.label}
                  </a>
                </li>)}
            </ul>
          </div>
        </div>

        <div className="mt-14 flex flex-col gap-2 border-t border-white/10 pt-7 text-[13px] text-chalk/40 sm:flex-row sm:items-center sm:justify-between" data-id="element-235" data-mp="12cd8w2guqndh">
          <p data-id="element-236" data-mp="sjfuo8iw7kko">
            © {new Date().getFullYear()} {business.name}. All rights reserved.
          </p>
          <p data-id="element-237" data-mp="1q1660297n19o">{business.contact} · EEAutomotiveRepair.com</p>
        </div>
      </div>
    </footer>;
}